var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPleaseWaitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5385 17.6923C49.5385 15.7381 47.9542 14.1538 46 14.1538C44.0458 14.1538 42.4615 15.7381 42.4615 17.6923V49.5385C42.4615 51.4927 44.0458 53.0769 46 53.0769H67.2308C69.185 53.0769 70.7692 51.4927 70.7692 49.5385C70.7692 47.5842 69.185 46 67.2308 46H49.5385V17.6923Z",
    fill: "#2E7DF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 0C20.6035 0 0 20.6035 0 46C0 71.3965 20.6035 92 46 92C71.3965 92 92 71.3965 92 46C92 20.6035 71.3965 0 46 0ZM7.07692 46C7.07692 24.5119 24.5119 7.07692 46 7.07692C67.4881 7.07692 84.9231 24.5119 84.9231 46C84.9231 67.4881 67.4881 84.9231 46 84.9231C24.5119 84.9231 7.07692 67.4881 7.07692 46Z",
    fill: "#2E7DF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleaseWaitIcon);
export default __webpack_public_path__ + "static/media/please-wait-icon.d525d37c7db277dedc5267a6086d7136.svg";
export { ForwardRef as ReactComponent };